import { CONSENT_DOC_ID, type ConsentDocKind } from '@/shared/data-types';
import { UI_TEXT } from '@/shared/languages';
import { ErrorState, Spinner } from '@/shared/ui';
import { useConsentsQuery } from '../api/use-consents.query';
import { ConsentDocBody } from './consent-doc-body';

export interface ConsentDocContentProps {
  kind: ConsentDocKind;
}

/**
 * 지목한 약관 하나의 원문 — 목록(v3 `GET /consents`, 비인증)에서 `CONSENT_DOC_ID[kind]` 로 집어 렌더.
 * BE 에 단건 조회가 없어 목록을 받아 고르는 구조지만, 목록을 이미 띄운 표면(고객센터)과 **같은 query**
 * 라서 RQ dedup 으로 재요청이 나가지 않는다. `AgreementContent`(v2) 와 같은 역할이되 소스가 v3 다.
 *
 * 목록은 왔는데 해당 ID 가 없으면(코드 재배정·미배포) 빈 화면 대신 에러 표면 — 조용히 사라지면
 * 스토어 심사 동선에서 "약관 없음"으로 읽힌다.
 */
export function ConsentDocContent({ kind }: ConsentDocContentProps) {
  const { data, isPending, isError, refetch } = useConsentsQuery();

  if (isPending) {
    return (
      <div className="flex justify-center py-16">
        <Spinner className="size-6 text-muted-foreground" />
      </div>
    );
  }

  const consent = data?.find((doc) => doc.consentId === CONSENT_DOC_ID[kind]);
  if (isError || !consent) {
    return <ErrorState description={UI_TEXT.AGREEMENT_ERROR} onRetry={() => refetch()} />;
  }

  return <ConsentDocBody consent={consent} />;
}
